<template>
  <div
    class="modal fade"
    id="exampleModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
    data-backdrop="false"
    data-dismiss="modal"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Nueva Devolución</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="col-12">
            <TiendaSelectComponent :current="current" />
          </div>
          <div class="col-12">
            <ProveedoresSelectComponent :current="current" />
          </div>
          <div class="col-12">
            <label>Motivo de Devolución</label>
            <input
              v-model="current.observacion"
              autofocus="autofocus"
              class="form-control"
              placeholder="Motivo de Devolución"
              type="text"
            />
            <small
              v-if="current.errors && current.errors.observacion"
              class="form-text text-danger"
              >{{ current.errors.observacion[0] }}</small
            >
          </div>
        </div>
        <div class="modal-footer">
          <div class="col-12">
            <button
              type="button"
              class="btn btn-primary btn-block"
              @click="guardar"
            >
              Guardar
            </button>
            <br />
            <button
              type="button"
              class="btn btn-secondary btn-block"
              data-dismiss="modal"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";
import DevolucionesProveedoresService from "@/services/inventario/DevolucionesProveedoresService";
import CommonService from "@/services/commons/CommonService";
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";

export default {
  components: {
    PaginationComponent,
    TiendaSelectComponent,
    ProveedoresSelectComponent,
  },
  props: {},
  data() {
    return {
      error: {},
      current: {
        tienda: "",
        fecha: "",
        producto: "",
        errors: "",
      },
    };
  },
  computed: {},
  mounted() {
    let self = this;
    CommonService.fecha_actual().then((res) => {
      self.current.fecha = res.data.fecha_actual;
    });
  },
  methods: {
    formatoFecha() {
      let self = this;
      self.current.fecha = self.current.fecha.replace(/\//g, "-");
    },
    guardar() {
      let self = this;
      let current = Object.assign({}, self.current);
      if (self.current.proveedor) {
        current.proveedor = self.current.proveedor.codigo;
      }
      DevolucionesProveedoresService.save(current)
        .then((response) => {
          Notifications.alert.success(
            "Devolucion a Proveedor",
            "Se ha guardado la Información."
          );
          if (current.id == null) {
            self.$router.push({
              name: "wms-devolucion-provedor-editar",
              params: { id: response.data.id },
            });
            $("#myModal").modal("hide");
            self.refreshCurrent();
          }
        })
        .catch((error) => {
          Notifications.alert.error(
            "Crear Devolución",
            error.response.data.detail
          );
          self.current.errors = error.response.data;
        });
    },
  },
};
</script>
